/**
 * @license Siftrock
 * (c) 2014-2018 Siftrock, Inc. http://siftrock.com
 * Unauthorized copying of this file, via any medium is strictly prohibited
 */

import { Component, OnInit, ViewChild } from '@angular/core';
import * as _ from 'lodash';

import { ContactService } from '../services/contact.service';
import { SourceService } from '../services/source.service';
import { SessionService } from '../services/session2.service';
import { AuthService } from '../services/auth.service';
import { CacheService } from '../global/ng2-cache/services/cache.service';
import { ErrorService } from '../services/error.service';
import { GlobalMessageService } from '../services/global-message.service';
import { DriftService } from '../services/drift.service';

import { DateRangePickerComponent } from '../global/date-range/date-range-picker.component';
import { Constants, EmailType, ContactQuality } from '../global/constants';
//import { Animations } from '../global/animations';

@Component({
  selector: 'app-contacts',
  templateUrl: './contacts.component.html'
  // host: { '[@routerTransition]': 'true' },
  // animations: Animations.page
})
export class ContactsComponent implements OnInit {

  loadingPage: boolean = true;
  session: any;
  currentType: EmailType;
  currentQuality: ContactQuality;
  contacts: Array<any> = [];
  newContacts: number = 0;
  existingContacts: number = 0;
  perPage: number = 15;
  numPages: number = 0;
  exportData: string;
  currentContactType: string = 'All contacts';

  //source dropdown settings
  sources: any[] = [];
  selectedSources: any[] = [];
  sourceDDSettings: any = {
    text: 'Select source(s)',
    unSelectAllText: 'Remove all',
    enableSearchFilter: true,
    badgeShowLimit: 0
  };

  sourceAdd(item) {
    this.filterSource();
  }

  sourceRemove(item) {
    this.filterSource();
  }

  sourceAddAll(items) {
    this.filterSource();
  }

  sourceRemoveAll(items) {
    this.filterSource();
  }


  @ViewChild(DateRangePickerComponent) datePicker: DateRangePickerComponent;

  dateRangeOptions: any = {
    minDate: '01/01/2015',
    format: 'MM/DD/YYYY',
    autoApply: true
  };

  constructor(private sessionService: SessionService,
    private authService: AuthService,
    private cacheService: CacheService,
    private errorService: ErrorService,
    private contactService: ContactService,
    private sourceService: SourceService,
    private globalMessageService: GlobalMessageService,
    private driftService: DriftService,
    private constants: Constants) { }

  ngOnInit() {
    this.session = this.cacheService.get('session');
    if (!this.session) {
      this.sessionService.getSession(true).subscribe(
        (session: any) => {
          this.session = session;
          this.initView();
        }
      )
    }
    else {
      this.initView();
    }
  }


  filterDate(range: any) {
    this.dateRangeOptions.startDate = range.start;
    this.dateRangeOptions.endDate = range.end;

    if (range.numDays) {
      this.session.contact_filters.days = range.numDays;
      this.session.contact_filters.range = null;
    }
    else {
      this.session.contact_filters.days = 0;
      this.session.contact_filters.range = {
        start: range.start,
        end: range.end
      }
    }

    this.session.contact_filters.current_page = 0;
    this.session.contact_filters.new_page = 1;
    this.session.contact_filters.firstId = null;
    this.session.contact_filters.lastId = null;
    this.resetData(true);
    this.saveSession();
  }

  filterType(type: EmailType) {
    this.currentType = type;
    this.session.contact_filters.type = type.typeName;
    this.session.contact_filters.page = 1;
    this.resetData(true);
    this.saveSession();
  }

  filterSource() {
    //12-31-17 changing how selected sources are stored in session
    // the next line can be deleted after 3 months or so..say March of 2018?
    delete this.session.contact_filters.source;

    this.session.contact_filters.sources = _.map(this.selectedSources, (s: any) => { return s.id });
    this.session.contact_filters.current_page = 0;
    this.session.contact_filters.new_page = 1;
    this.session.contact_filters.firstId = null;
    this.session.contact_filters.lastId = null;
    this.resetData(true);
    this.saveSession();
  }

  filterQuality(quality: ContactQuality) {
    this.currentQuality = quality;
    this.session.contact_filters.quality = quality.quality;
    this.session.contact_filters.page = 1;
    this.resetData(true);
    this.saveSession();
  }

  filterSender(sender: boolean) {
    if (sender != this.session.contact_filters.sender) {
      this.session.contact_filters.sender = !this.session.contact_filters.sender;
      this.session.contact_filters.page = 1;
      this.resetData(false);
      this.saveSession();
    }
  }

  filterSearch() {
    this.session.contact_filters.page = 1;
    this.resetData(true);
    this.saveSession();
  }

  changePage(page) {
    this.session.contact_filters.page = page;
    this.resetData(true);
    this.saveSession();
  }

  setSort(fieldName) {
    var direction = 1;
    if (this.session.contact_filters.sort.field == fieldName) {
      direction = (-1) * (this.session.contact_filters.sort.direction);
    }
    this.session.contact_filters.sort = {
      field: fieldName,
      direction: direction
    };

    this.resetData(false)
    this.saveSession();
  }

  getTypeClass(type: string) {
    let cssClass: string = 'category-3';
    let et: EmailType =
      this.constants.emailTypes.find((et) => {
        return et.display == type;
      });
    if (et) {
      cssClass = et.cssClass;
    }
    return cssClass;
  }

  export() {
    this.globalMessageService.message('Your export should download in the next few seconds');
    var options = {
      filter: this.createFilter()
    };
    this.contactService.getExport(options).subscribe(
      (result: any) => {
        this.exportData = result;
        this.driftService.track('generated-export', { type: 'contacts' });
      },
      error => {
      }
    );
  }

  reset() {
    this.resetFilters();
    this.initView();
    this.datePicker.refresh();
    this.globalMessageService.message('Contact filters reset');
  }

  private initView() {
    // make sure contact filters exist for this user
    if (!this.session.contact_filters || !this.session.contact_filters.last_changed) {
      this.resetFilters();
    }

    var now = new Date();
    var lastUpdate = new Date(this.session.contact_filters.last_changed);
    if (now.getTime() - lastUpdate.getTime() > 900000) {
      // 900000ms = 15 minutes. Let's reset filters if it's been more than 15 minutes since they were last last changed
      this.resetFilters();
    }

    this.currentType = this.constants.emailTypes.find((i) => {
      return i.typeName == this.session.contact_filters.type;
    });

    this.currentQuality = this.constants.contactQualities.find((i) => {
      return i.quality == this.session.contact_filters.quality;
    });


    if (this.session.contact_filters.range) {
      // custom range is currently selected
      this.dateRangeOptions.startDate = new Date(this.session.contact_filters.range.start);
      this.dateRangeOptions.endDate = new Date(this.session.contact_filters.range.end);
    }
    else {
      // standard "time ago" is currently selected
      this.dateRangeOptions.endDate = new Date();
      this.dateRangeOptions.startDate = new Date();
      if (this.session.contact_filters.days > 0) {
        this.dateRangeOptions.startDate.setDate(this.dateRangeOptions.endDate.getDate() - this.session.contact_filters.days + 1);
      }
      else {
        // special case for "yesterday"
        this.dateRangeOptions.startDate.setDate(this.dateRangeOptions.endDate.getDate() - 1);
        this.dateRangeOptions.endDate.setDate(this.dateRangeOptions.endDate.getDate() - 1);
      }
    }

    // pre-load sources in case they are needed
    this.sourceService.getSources().subscribe(
      (result: any) => {
        this.sources = _.map(result, (s: any) => {
          return { id: s._id, itemName: (s.email_address.length > 26 ? (s.email_address.substring(0, 23) + '...') : s.email_address) };
        });

        //mark any sources selected that are in the session
        this.session.contact_filters.sources.forEach(s => {
          var found_source = _.find(this.sources, (source: any) => {
            return source.id == s;
          })
          if (found_source) {
            this.selectedSources.push(found_source);
          }
        });

        this.resetData(true);
      },
      error => {

      }
    )
  }

  private resetData(refreshCounts: boolean) {
    this.loadingPage = true;
    this.contacts = [];

    if (refreshCounts) {
      this.getCounts((err) => {
        if (this.newContacts + this.existingContacts == 0) {
          this.loadingPage = false;
          this.session.contact_filters.page = 1;
          this.saveSession();
        }
        else if (this.newContacts == 0 &&
          this.existingContacts > 0 &&
          this.session.contact_filters.sender == false) {
          this.session.contact_filters.sender = true;
          this.saveSession();
          this.changePageInternal();
        }
        else if (this.newContacts > 0 &&
          this.existingContacts == 0 &&
          this.session.contact_filters.sender == true) {
          this.session.contact_filters.sender = false;
          this.saveSession();
          this.changePageInternal();
        }
        else {
          this.changePageInternal();
        }
      });
    }
    else {
      this.changePageInternal();
    }
  }

  private getCounts(callback) {
    this.loadingPage = true;
    var options = {
      filter: this.createFilter()
    };

    this.contactService.getCount(options).subscribe(
      (result: any) => {
        this.newContacts = result.new;
        this.existingContacts = result.existing;
        callback(null);
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'contacts.component', 'getCounts');
        callback(error);
      });
  }

  private changePageInternal() {
    this.loadingPage = true;
    var sort = {};
    sort[this.session.contact_filters.sort.field] = this.session.contact_filters.sort.direction;

    var options = {
      filter: this.createFilter(),
      sort: sort,
      limit: this.perPage,
      page: this.session.contact_filters.page
    };

    this.contactService.getPaginated(options).subscribe(
      (result: any) => {
        this.contacts = result;
        this.contacts.forEach((c) => {
          c.type = this.constants.emailTypes.find((ct) => {
            return ct.typeName == c.email_detail[c.email_detail.length - 1].type;
          }).display;

          c.seen_subject = c.email_detail[c.email_detail.length - 1].subject;
          c.seen_email_id = c.email_detail[c.email_detail.length - 1].ed_id;
        });

        var activeCount = 0;
        if (this.session.contact_filters.sender) {
          activeCount = this.existingContacts;
        }
        else {
          activeCount = this.newContacts;
        }

        this.numPages = Math.floor(activeCount / this.perPage);
        if (activeCount % this.perPage > 0) {
          this.numPages++;
        }
        this.loadingPage = false;
      },
      error => {
        this.globalMessageService.error();
        this.errorService.log(error, 'contacts.component', 'changePageInternal');
      });
  }

  private saveSession() {
    this.session.contact_filters.last_changed = new Date();
    this.sessionService.saveSession(this.session).subscribe(
      (result: any) => {
        // Nothing
      },
      err => {
        this.errorService.log(err, 'contacts.component', 'saveSession');
      }
    )
  }

  private createFilter() {

    var startDT = new Date(this.dateRangeOptions.startDate);
    startDT.setUTCHours(0, 0, 0, 0);
    var endDT = new Date(this.dateRangeOptions.endDate);
    endDT.setUTCHours(23, 59, 59, 999);

    var filter: any = {
      type: this.session.contact_filters.type,
      sender: this.session.contact_filters.sender,
      confidence: this.session.contact_filters.quality,
      ls_date: { '$gte': startDT.toISOString(), '$lt': endDT.toISOString() },
      search: this.session.contact_filters.search.length > 1 ? this.session.contact_filters.search : ''
    };

    if (this.session.contact_filters.sources.length > 0 && this.session.contact_filters.sources.length != this.sources.length) {
      filter.source = this.session.contact_filters.sources;
      // filter['$or'] = _.map(this.session.contact_filters.sources, (s: any) => {
      //   return { last_source_id: s };
      // });
    }
    return filter;
  }

  private resetFilters() {
    this.session.contact_filters = {
      sender: false,
      type: 'all',
      sources: [],
      quality: 0,
      days: 30,
      range: null,
      search: '',
      page: 1,
      sort: {
        field: 'ls_date',
        direction: -1
      }
    };
    this.selectedSources = [];

    this.saveSession();
  }

}



// WEBPACK FOOTER //
// ./client/app/contacts/contacts.component.ts